import { render, staticRenderFns } from "./AgeRestriction.vue?vue&type=template&id=519e3bb2&scoped=true&"
import script from "./AgeRestriction.vue?vue&type=script&lang=js&"
export * from "./AgeRestriction.vue?vue&type=script&lang=js&"
import style0 from "./AgeRestriction.vue?vue&type=style&index=0&id=519e3bb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e3bb2",
  null
  
)

export default component.exports